import React from 'react';
import { SourceMeta } from './SourceMeta';

const List = ({ title, items, testId }) => (items?.length ? (
  <div data-testid={testId}>
    <p className="text-xs font-semibold text-gray-300 mt-3 mb-1">{title}</p>
    <ul className="list-disc pl-5 space-y-1 text-sm text-gray-300">{items.map((t, i) => <li key={i}>{t}</li>)}</ul>
  </div>
) : null);

export const ExplanationPanel = ({ explanation }) => {
  if (!explanation) return null;
  if (!explanation.available) {
    return <p className="text-sm text-gray-400" data-testid="research-explanation-unavailable">Explanation unavailable: {explanation.reason}</p>;
  }
  return (
    <div className="p-4 rounded-xl bg-white/5 border border-white/10" data-testid="research-explanation">
      <p className="text-xs text-gray-500 mb-2" data-testid="research-explanation-label">
        {explanation.generatedBy === 'ai' ? `AI-generated explanation (${explanation.model}) of supplied facts` : explanation.notice}
      </p>
      <p className="text-sm text-gray-200">{explanation.summary}</p>
      <List title="Observations" items={explanation.observations} testId="research-observations" />
      <List title="Limitations" items={explanation.limitations} testId="research-limitations" />
      <List title="Research questions to explore" items={explanation.researchQuestions} testId="research-followups" />
      {(explanation.sources || []).map((s) => (
        <SourceMeta key={s.url} source={{ ...s, retrievedAt: explanation.generatedAt }} asOfLabel="Data as of" testId="research-explanation-source" />
      ))}
    </div>
  );
};
